$primary-green: #81ba43;
$secondary-green: #7fb02f;

.wrap {
	padding: 0 0.7rem 0 0.7rem;
}

.overlay {
	position: fixed;
	inset: 0;
	background: rgba(15, 23, 42, 0.35);
	display: grid;
	place-items: center;
	padding: 0.75rem;
	z-index: 100;
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.18s ease;
}
.show {
	opacity: 1;
	pointer-events: auto;
}
.hide {
	opacity: 0;
	pointer-events: none;
}

.panel {
	width: 100%;
	max-width: 960px;
	max-height: 80vh;
	background: #fff;
	border-radius: 0.75rem;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
	display: flex;
	flex-direction: column;
	overflow: hidden;
	transform: translateY(8px);
	transition:
		transform 0.18s ease,
		opacity 0.18s ease;
	opacity: 0;
}
.panelIn {
	transform: translateY(0);
	opacity: 1;
}
.panelOut {
	transform: translateY(8px);
	opacity: 0;
}

.header {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 0.75rem;
	padding: 0.5rem 1rem;
	border-bottom: 1px solid #e5e7eb;
}
.titles {
	flex: 1 1 auto;
	min-width: 0;
}
.title {
	margin: 0;
	font-size: 1.125rem;
	line-height: 1.75rem;
	font-weight: 700;
	color: #111827;
}
.close {
	border: 1px solid #e5e7eb;
	background: #fff;
	color: #111827;
	width: 36px;
	height: 36px;
	border-radius: 0.5rem;
	cursor: pointer;
	display: grid;
	place-items: center;
	transition: background 0.15s ease;
	&:hover {
		background: #f3f4f6;
	}
}

.content {
	padding: 1rem;
	overflow: auto;
}
.grid {
	display: grid;
	gap: 0.75rem;
	grid-template-columns: repeat(12, minmax(0, 1fr));
}
.field {
	grid-column: span 6;
}
.label {
	display: block;
	font-weight: 600;
	font-size: 0.875rem;
	color: #374151;
	margin-bottom: 0.35rem;
}

.input {
	width: 100%;
	border: 1px solid #e5e7eb;
	border-radius: 0.5rem;
	padding: 0.5rem 0.65rem;
	font-size: 0.95rem;
	color: #111827;
	outline: none;
	background: #fff;
	transition:
		border-color 0.15s ease,
		box-shadow 0.15s ease;
	&:focus {
		border-color: #c7d2fe;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
	}
}

.selectWrap {
	position: relative;
}
.selectIcon {
	position: absolute;
	right: 0.5rem;
	top: 50%;
	transform: translateY(-50%);
	pointer-events: none;
	color: #6b7280;
}
.select {
	appearance: none;
	padding-right: 2rem;
}

.switch {
	display: inline-flex;
	align-items: center;
	gap: 0.5rem;
	cursor: pointer;
	user-select: none;
	input {
		display: none;
	}
}
.slider {
	width: 42px;
	height: 22px;
	background: #e5e7eb;
	border-radius: 9999px;
	position: relative;
	transition: background 0.15s ease;
	&::after {
		content: "";
		position: absolute;
		top: 2px;
		left: 2px;
		width: 18px;
		height: 18px;
		background: #fff;
		border-radius: 9999px;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
		transition: transform 0.15s ease;
	}
}
.switch input:checked + .slider {
	background: $secondary-green;
}
.switch input:checked + .slider::after {
	transform: translateX(20px);
}
.switchLabel {
	font-size: 0.9rem;
	color: #374151;
}

.footer {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.75rem;
	padding: 0.9rem 1rem;
	border-top: 1px solid #e5e7eb;
}
.footerLeft,
.footerRight {
	display: flex;
	align-items: center;
	gap: 0.5rem;
}

@media (max-width: 1024px) {
	.panel {
		max-width: 760px;
	}
}

@media (max-width: 768px) {
	.wrap {
		padding: 0 0.5rem;
	}
	.panel {
		max-width: 100%;
		height: 90vh;
	}
	.grid {
		grid-template-columns: repeat(6, minmax(0, 1fr));
	}
	.field {
		grid-column: span 6;
	}
}

@media (max-width: 420px) {
	.title {
		font-size: 1rem;
	}
	.footer {
		flex-direction: column;
		align-items: stretch;
		gap: 0.5rem;
	}
	.footerRight {
		justify-content: space-between;
	}
}
